import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { ContextPro } from "../../../App";
import BreadCrumb from "../../BreadCrumb";
import CanvasInCenter from "../../Commons/CanvasInCenter";
import Loader from "../../loader";
import MassageError from "../../MassageError";
import BtnAdmin from "../BtnAdmin";
import TaHeadAdmin from "../TaHeadAdmin";

import { adminPanelAPIs } from "../../../utils/config";
import { urlApiEd, urlApiGet } from "../../../utils/utilsFuc";
import'../Admin.css'

export default function ShowCategory() {
  const { dataCate, setDataCate } = useContext(ContextPro);
  const [search, setSearch] = useState([]);

  //   const [data, setData] = useState(dataCate);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    SearchAdmin();
    if (dataCate.length) setLoading(false);
  }, [dataCate]);
  const handleDeleteCat = (id) => {
    // start loader
    setLoading(true);
    // delete
    urlApiEd(adminPanelAPIs.Categotry.deleteCategoriesURL(id))
      .then(() => {
        // stop loader
        setLoading(false);

        // show notification
        // update data cat
        setDataCate((prev) => prev.filter((item) => item.id !== id));
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
      });
  };

  function SearchAdmin(value = "") {
    setSearch(
      dataCate?.filter((e) =>
        (e.name).toLowerCase().trim().includes(value)
      )
    );
  }

  return (
    <div className=" container">
      <BreadCrumb />
      <Link to={"/Admin/AddCate"} className="btn-add btn-add-moblie">
        <BtnAdmin title={"Add"} bgcolor="green" />
      </Link>

      <div className=" search-details">
        <input
          type="text"
          placeholder="Search"
          onChange={(e) => SearchAdmin(e.currentTarget.value.toLowerCase().trim())}
        />
        <div>ok</div>
      </div>
      <div className=" table-admin">
        <table className=" ">
          <TaHeadAdmin
            arrtitle={["Name", "Description", "ParentId", "action"]}
            key={"table-brand"}
          />
          <tbody>
            {(search.length ? search : dataCate)?.map((e) => (
              <tr>
                <td>{e.name}</td>
                <td>{e.description}</td>
                <td>{dataCate?.map((t) => t.id == e.parentId && t.name)}</td>
                <td className=" d-flex justify-content-center align-items-center gap-3">
                  <Link
                    to={"/Admin/EditCate"}
                    state={{
                      id: e.id,
                      name: e.name,
                      descr: e.description,
                      parentId: e.parentId,
                    }}
                  >
                    <BtnAdmin title={"Edit"} bgcolor="green" />
                  </Link>

                  <Link
                    to={"/Admin/Addproduct"}
                    state={{ id: e.id, name: e.name }}
                  >
                    <BtnAdmin title={"Add Product"} bgcolor="#2196f3" />
                  </Link>
                  <BtnAdmin
                    title={"Delete"}
                    onclick={() => handleDeleteCat(e.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {loading ? <Loader /> : ""}
      <CanvasInCenter setError={setError} showcenter={error}>
        <MassageError>
          This Category has SubCategory <br />
          First delete the children, then this category
        </MassageError>
      </CanvasInCenter>
    </div>
  );
}
